import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/MonthlyInfluence',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluence-index" */ '~/pages/MonthlyInfluence/pages/index'
        )
    ),
  },
  {
    path: '/MonthlyInfluence/reward',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluence-reward" */ '~/pages/MonthlyInfluence/pages/reward'
        )
    ),
  },
  {
    path: '/MonthlyInfluence/honor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluence-honor" */ '~/pages/MonthlyInfluence/pages/honor'
        )
    ),
  },
  {
    path: '/MonthlyInfluence/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-MonthlyInfluence-rule" */ '~/pages/MonthlyInfluence/pages/rule'
        )
    ),
  },
] as RouteConfig[]
